
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Index() {
  const { isAuthenticated } = useAuth();
  
  useEffect(() => {
    document.title = "MansFilms - Admin Panel";
  }, []);

  // Redirect to appropriate page based on authentication status
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  } else {
    return <Navigate to="/login" />;
  }
}
